import React from "react";
import {
  additionalModalClosed,
  certificateModalOpened,
} from "../store/components";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CancelIcon from "@material-ui/icons/Cancel";
import PlusIcon from "@material-ui/icons/Add";
import Minimize from "@material-ui/icons/Remove";
import { OrangeButton } from "../general/OrangeButton";
import * as theme from "../theme";
import { makeStyles } from "@material-ui/core/styles";
import {
  getPolicyStatusData,
  getStatusApi,
  createPolicyApi,
  addAdditionalInsurers,
  deleteAdditionalInsurers,
} from "../store/policyStatus";
import {
  allCertificateHolderList,
  getCertificateHolderListDetails,
} from "../store/certificate";
import { getBinderDetails, getSelectedBinderDetails } from "../store/mybinder";
import { getCertificateFlag } from "../store/certificate";
import { useState, useEffect } from "react";
import translations from "../utils/translations";
import { getBrokerInformation } from "../store/broker";

const AdditionalInsuredsModal = (props) => {
  const dispatch = useDispatch();
  const certificateFlag = useSelector(getCertificateFlag);
  const allAdditional = useSelector(getCertificateHolderListDetails);
  const [icon, setIcon] = useState(true);
  const additionalInsuredTypeModal = {
    additionalInsured: "Additional Insured",
    lossPayee: "Loss Payee",
  };
  const Id = props.policyId;
  const additionalDataModel = {
    isNew: true,
    interestname: "",
    type: additionalInsuredTypeModal.additionalInsured,
    address: {
      addr_line1: "",
      addr_line2: "",
      city: "",
      country: "",
      postal_code: "",
      province: "",
    },
    isAdditionalInsured: false,
    isLossPayee: false,
    interestnature: "",
    locationofinterest: "",
    crossliability: false,
    noticerequireddays: "",
    subrogationwaiverrequired: false,
  };
  const [nameError, setNameError] = useState("");
  const [add1Error, setAdd1Error] = useState("");
  const [add2Error, setAdd2Error] = useState("");
  const [cityError, setCityError] = useState("");
  const [provinceError, setProvinceError] = useState("");
  const [postalCode, setPostalCodeError] = useState("");
  const [countryError, setCountryError] = useState("");
  let [additinalDetail, setAdditionalDetail] = useState([]);
  const additionalDetails = useSelector(getSelectedBinderDetails);
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  const additionalInsuredTranslations =
    translations[languagepreference].additionalInsurerModal;
  const handleAdditionalAddClick = () => {
    setAdditionalDetail([...additinalDetail, { ...additionalDataModel }]);
  };
  useEffect(() => {
    if (additinalDetail.length === 0) {
      setAdditionalDetail([{ ...additionalDataModel }]);
    }
  }, []);

  // useEffect(() => {
  //   if (allAdditional) {
  //     setAdditionalDetail(allAdditional);
  //   } else {
  //     setAdditionalDetail([{ ...additionalDataModel }]);
  //   }
  // }, [allAdditional]);
  useEffect(() => {
    if (allAdditional && allAdditional.length > 0) {
      setAdditionalDetail(allAdditional);
    } else {
      setAdditionalDetail([{ ...additionalDataModel }]);
    }
  }, [allAdditional]);
  // Update the initial state of additionalDataModel with the appropriate checkbox values
  useEffect(() => {
    const initialAdditionalData = {
      ...additionalDataModel,
      isAdditionalInsured: certificateFlag.data === 0, // Set the value based on certificateFlag.data
      isLossPayee: false, // You can set this to true if needed initially
      subrogationwaiverrequired: false, // You can set this to true if needed initially
    };
    setAdditionalDetail([initialAdditionalData]);
  }, [certificateFlag.data]);

  // Ensure checkboxes are updated when certificateFlag.data changes
  useEffect(() => {
    const updatedAdditionalData = additinalDetail.map((additional) => ({
      ...additional,
      isAdditionalInsured: certificateFlag.data === 0,
    }));
    setAdditionalDetail(updatedAdditionalData);
  }, [certificateFlag.data]);

  const useStyles = makeStyles(
    theme.customMaterialUIClassForScrollBarDarkBackgrond
  );
  const classes = useStyles();

  const onAdditionalHandler = (e) => {
    e.preventDefault();
    const binderId = props.binderId;
    const body = {
      policyid: Id,
      additionalinsurers: additinalDetail,
    };

    dispatch(addAdditionalInsurers(body)).then(() => {
      toast.success("Additional insurer added");
      if (certificateFlag.data === 0) {
        dispatch(additionalModalClosed());
        dispatch(certificateModalOpened());
        dispatch(allCertificateHolderList(Id));
      } else {
        dispatch(allCertificateHolderList(Id));
        dispatch(additionalModalClosed());
      }
    });
  };

  const getAdditionalList = () => {
    return [...additinalDetail];
  };

  const setAdditionalDetailsList = (list) => {
    setAdditionalDetail(list);
  };
  const hDist = {
    headingHeight: "10%",
    remainingHeight: "10%",
  };
  const heights = {
    desc: "8%",
    proceedbutton: "8%",
    somegapbetween: "2%",
    remainingHeight: "",
  };
  const handleMinus = () => {
    setIcon(true);
  };
  const handlePlus = () => {
    setIcon(false);
  };
  hDist.remainingHeight = `calc(100% - ${hDist.headingHeight})`;
  return (
    <>
      <div
        style={{
          flexDirection: "column",
          width: "100%",
          height: "100%",
          // padding: "2vmin",
        }}
      >
        <div
          style={{
            height: hDist.headingHeight,
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: theme.COLORS.secondary_skyblue,
              fontSize: "1.9vmin",
              letterSpacing: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              fontFamily: "GibsonRegular",
            }}
          >
            {additionalInsuredTranslations.heading}
          </div>
        </div>
        <div
          style={{
            flexDirection: "column",
            width: "100%",
            height: hDist.remainingHeight,
            backgroundColor: theme.COLORS.primary_navyblue,
          }}
        >
          <div style={{ position: "absolute", top: 0, right: 0 }}>
            <CancelIcon
              fontSize="large"
              style={{ cursor: "pointer", color: "white" }}
              onClick={() => {
                if (certificateFlag.data === 0) {
                  dispatch(additionalModalClosed());
                  dispatch(certificateModalOpened());
                } else {
                  dispatch(additionalModalClosed());
                }
              }}
            ></CancelIcon>
          </div>

          <form onSubmit={onAdditionalHandler}>
            <div
              className=" d-flex justify-content-end "
              style={{
                height: "5vmin",
                marginRight: "2rem",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: heights.desc,
                  fontSize: "1.7vmin",
                  letterSpacing: 1,
                  fontFamily: "GibsonLight",
                  marginLeft: "1.5rem",
                }}
              >
                <b>{additionalInsuredTranslations.description}</b>
              </div>
              {additinalDetail && additinalDetail.length + 1 && (
                <OrangeButton
                  width="20%"
                  fontSize="2.0vh"
                  text={additionalInsuredTranslations.addButton}
                  color={theme.COLORS.secondary_orange}
                  onClick={handleAdditionalAddClick}
                />
              )}
            </div>
            <div
              style={{
                height: "570px",
                paddingBottom: "1rem",
                padding: "2vmin",
                overflow: "auto",
                overflowX: "hidden",
              }}
              className={`wrapper searchDiv ${classes.responses}`}
            >
              {additinalDetail?.map((additional, i) => {
                return (
                  <>
                    <div class="card mb-3">
                      <div class="card-header" id="headingOne">
                        <div className="form-group d-flex ">
                          <label
                            for="inputEmail3"
                            className=" col-form-label text-dark"
                          >
                            {additionalInsuredTranslations.entityLabel}
                          </label>
                          <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                            <label
                              for="inputEmail3"
                              className=" col-form-label text-dark "
                            >
                              <div
                                style={{
                                  marginLeft: "10rem",
                                }}
                              >
                                <b>{additional && additional.interestname}</b>
                              </div>
                            </label>
                          </div>
                          {!icon ? (
                            <Minimize
                              onClick={handleMinus}
                              fontSize="large"
                              style={{
                                cursor: "pointer",
                                color: "white",
                                backgroundColor: "black",
                                borderRadius: "20px",
                                float: "right",
                              }}
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseExample${i}`}
                              aria-expanded={icon}
                              aria-controls={`collapseExample${i}`}
                            ></Minimize>
                          ) : null}
                          {icon ? (
                            <PlusIcon
                              onClick={handlePlus}
                              fontSize="large"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "black",
                                float: "right",
                                marginLeft: "5%",
                                borderRadius: "20px",
                              }}
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseExample${i}`}
                              aria-expanded={icon}
                              aria-controls={`collapseExample${i}`}
                            ></PlusIcon>
                          ) : null}
                        </div>
                      </div>

                      <div class="collapse" id={`collapseExample${i}`}>
                        <div key={`additional-${i}`} className="card">
                          <div className="card-body">
                            <div className="container-fluid">
                              <div className="form-group row">
                                <label
                                  for="inputEmail3"
                                  className="col-4 text-dark"
                                >
                                  {additionalInsuredTranslations.entityLabel}
                                </label>
                                <input
                                  type="text"
                                  class="form-control col-8"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  placeholder={
                                    additionalInsuredTranslations.entityLabel
                                  }
                                  required
                                  onChange={(event) => {
                                    setNameError("");
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.interestname = event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  value={
                                    additional ? additional.interestname : ""
                                  }
                                />
                              </div>

                              <div className="form-group row">
                                <label
                                  for="inputEmail3"
                                  className="col-4 text-dark "
                                >
                                  {additionalInsuredTranslations.addressLine1}
                                </label>
                                <input
                                  type="text"
                                  class="form-control col-8"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  placeholder={
                                    additionalInsuredTranslations.addressLine1
                                  }
                                  onChange={(event) => {
                                    setAdd1Error("");
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.address.addr_line1 = event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  value={
                                    additional
                                      ? additional.address.addr_line1
                                      : ""
                                  }
                                />
                              </div>

                              <div className="form-group row">
                                <label
                                  for="inputEmail3"
                                  className="col-4 text-dark"
                                >
                                  {additionalInsuredTranslations.addressLine2}
                                </label>

                                <input
                                  type="text"
                                  class="form-control col-8"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  placeholder={
                                    additionalInsuredTranslations.addressLine2
                                  }
                                  onChange={(event) => {
                                    setAdd2Error("");
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.address.addr_line2 = event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  value={
                                    additional
                                      ? additional.address.addr_line2
                                      : ""
                                  }
                                />
                              </div>
                              <div className="form-group row">
                                <label
                                  for="inputEmail3"
                                  className="text-dark col-4 "
                                >
                                  {additionalInsuredTranslations.city}
                                </label>
                                <input
                                  type="text"
                                  class="form-control col-8"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  onChange={(event) => {
                                    setCityError("");
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.address.city = event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  placeholder={
                                    additionalInsuredTranslations.city
                                  }
                                  value={additional && additional.address.city}
                                />
                              </div>
                              <div className="form-group row ">
                                <label
                                  for="inputEmail3"
                                  className="text-dark col-4"
                                >
                                  {additionalInsuredTranslations.province}
                                </label>
                                <input
                                  type="text"
                                  className="form-control col-8"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  placeholder={
                                    additionalInsuredTranslations.province
                                  }
                                  onChange={(event) => {
                                    setProvinceError("");
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.address.province = event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  value={
                                    additional && additional.address.province
                                  }
                                />
                              </div>
                              <div className="form-group row">
                                <label
                                  for="inputEmail3"
                                  className="text-dark col-4"
                                >
                                  {additionalInsuredTranslations.postalCode}
                                </label>
                                <input
                                  type="text"
                                  className="form-control col-8"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  onChange={(event) => {
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.address.postal_code =
                                      event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  placeholder={
                                    additionalInsuredTranslations.postalCode
                                  }
                                  value={
                                    additional && additional.address.postal_code
                                  }
                                />
                              </div>
                              <div className="form-group row">
                                <label
                                  for="inputEmail3"
                                  className="text-dark col-4"
                                >
                                  {additionalInsuredTranslations.country}
                                </label>
                                <input
                                  type="text"
                                  className="form-control col-8"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  onChange={(event) => {
                                    setCountryError("");
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.address.country = event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  placeholder={
                                    additionalInsuredTranslations.country
                                  }
                                  value={
                                    additional && additional.address.country
                                  }
                                />
                              </div>
                              <div
                                className="row  "
                                style={{
                                  marginBottom: "2%",
                                  marginTop: "2%",
                                }}
                              >
                                <div className="text-dark col-sm-5">
                                  {
                                    additionalInsuredTranslations.checkboxesHeading
                                  }
                                </div>
                                <div className=" d-flex ">
                                  <div class="form-check ">
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      onChange={(event) => {
                                        const list = getAdditionalList();
                                        const obj = { ...list[i] };
                                        obj.isAdditionalInsured =
                                          event.target.checked;
                                        list[i] = { ...obj };
                                        setAdditionalDetailsList(list);
                                      }}
                                      defaultChecked={
                                        additional &&
                                        additional.isAdditionalInsured === true
                                      }
                                      id={`defaultCheck1${i}`}
                                    />
                                    <label
                                      className="form-check-label text-dark"
                                      for={`defaultCheck1${i}`}
                                    >
                                      {
                                        additionalInsuredTranslations.additionalInsured
                                      }
                                    </label>
                                  </div>
                                  <div class="form-check ml-5">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`defaultCheck2${i}`}
                                      onChange={(event) => {
                                        const list = getAdditionalList();
                                        const obj = { ...list[i] };
                                        obj.isLossPayee = event.target.checked;
                                        list[i] = { ...obj };
                                        setAdditionalDetailsList(list);
                                      }}
                                      defaultChecked={
                                        additional &&
                                        additional.isLossPayee === true
                                      }
                                    />
                                    <label
                                      className="form-check-label text-dark"
                                      for={`defaultCheck2${i}`}
                                    >
                                      {additionalInsuredTranslations.lossPayee}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row">
                                <label
                                  for="inputEmail3"
                                  className="text-dark col-4"
                                >
                                  {
                                    additionalInsuredTranslations.natureOfInterest
                                  }
                                </label>
                                <input
                                  type="text"
                                  class="form-control col-8"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  onChange={(event) => {
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.interestnature = event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  placeholder={
                                    additionalInsuredTranslations.natureOfInterest
                                  }
                                  value={
                                    additional && additional.interestnature
                                  }
                                />
                              </div>
                              <div className="form-group row">
                                <label
                                  for="inputEmail3"
                                  className="text-dark col-4"
                                >
                                  {
                                    additionalInsuredTranslations.locationOfInterest
                                  }
                                </label>
                                <input
                                  type="text"
                                  class="form-control col-8"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  onChange={(event) => {
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.locationofinterest = event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  placeholder={
                                    additionalInsuredTranslations.locationOfInterest
                                  }
                                  value={
                                    additional && additional.locationofinterest
                                  }
                                />
                              </div>

                              <div className="form-group row">
                                <label
                                  for="inputEmail3"
                                  className="col-4 text-dark "
                                >
                                  {additionalInsuredTranslations.noticePeriod}
                                </label>
                                <input
                                  type="text"
                                  class="form-control col-2"
                                  style={{
                                    color: theme.COLORS.dark_navy_blue,
                                    border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                    borderRadius: 5,
                                    backgroundColor:
                                      theme.COLORS.tertiary_ligthindigo,
                                  }}
                                  id="inputEmail3"
                                  placeholder={
                                    additionalInsuredTranslations.noticePeriod
                                  }
                                  onChange={(event) => {
                                    const list = getAdditionalList();
                                    const obj = { ...list[i] };
                                    obj.noticerequireddays =
                                      +event.target.value;
                                    list[i] = { ...obj };
                                    setAdditionalDetailsList(list);
                                  }}
                                  value={
                                    additional && additional.noticerequireddays
                                  }
                                />
                                <div className="custom-control custom-switch mt-2 ml-5">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input "
                                    style={{
                                      color: theme.COLORS.dark_navy_blue,
                                      border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                      borderRadius: 5,
                                      backgroundColor:
                                        theme.COLORS.tertiary_ligthindigo,
                                    }}
                                    id={`waiver${i}`}
                                    name={`waiver${i}`}
                                    defaultChecked={
                                      additional &&
                                      additional.subrogationwaiverrequired ===
                                        true
                                    }
                                    onChange={(event) => {
                                      const list = getAdditionalList();
                                      const obj = { ...list[i] };
                                      obj.subrogationwaiverrequired =
                                        event.target.checked;
                                      list[i] = { ...obj };
                                      setAdditionalDetailsList(list);
                                    }}
                                  />
                                  <label
                                    className="custom-control-label text-dark"
                                    htmlFor={`waiver${i}`}
                                  >
                                    {
                                      additionalInsuredTranslations.waiverOfSubrogation
                                    }
                                  </label>
                                </div>
                                <div className="custom-control custom-switch mt-2 ml-5">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input "
                                    id={`cross${i}`}
                                    name={`cross${i}`}
                                    onChange={(event) => {
                                      const list = getAdditionalList();
                                      const obj = { ...list[i] };
                                      obj.crossliability = event.target.checked;
                                      list[i] = { ...obj };
                                      setAdditionalDetailsList(list);
                                    }}
                                    defaultChecked={
                                      additional &&
                                      additional.crossliability === true
                                    }
                                  />
                                  <label
                                    className="custom-control-label text-dark"
                                    htmlFor={`cross${i}`}
                                  >
                                    {
                                      additionalInsuredTranslations.crossLiability
                                    }
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
            <div
              style={{
                width: "100%",
                height: heights.somegapbetween,
              }}
            ></div>
            <button
              className="col-sm-12 col-md-12 btn"
              style={{
                marginLeft: "1.6%",
                width: "96%",
                height: "8%",
                backgroundColor: "rgb(234, 143, 96)",
                fontSize: "1.9vmin",
                letterSpacing: "1px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "10px",
                cursor: "pointer",
                color: "white",
                fontFamily: "GibsonRegular",
                marginTop: "2%",
              }}
              type="submit"
            >
              <div> {additionalInsuredTranslations.saveButton} </div>
            </button>
          </form>
        </div>
      </div>
    </>
  );
};
const CommonHeading = ({ text }) => {
  return (
    <section
      style={{
        width: "100%",
        height: "4vh",
        fontSize: "2.2vmin",
        color: theme.COLORS.secondary_skyblue,
        display: "flex",
        alignItems: "center",
      }}
    >
      {text}
    </section>
  );
};
const CommonInputField = ({
  label = "Sample common label",
  onChange,
  value,
  placeholder,
}) => {
  return (
    <section
      style={{
        minHeight: "8vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: "2vh",
      }}
    >
      <div
        style={{
          width: "30%",
          paddingLeft: "7vmin",
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {label}
      </div>
      <div style={{ width: "50%", minHeight: "100%" }}>
        <input
          style={{
            width: "100%",
            height: "100%",
            padding: "2vmin",
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        ></input>
      </div>
    </section>
  );
};
export default AdditionalInsuredsModal;
